module.exports = __webpack_public_path__ + "img/upload.e89207762080ae24b0aa8cf0fdbed59b.e8920776.png";